import { createReducer, on } from '@ngrx/store';
import {
  IReckonIntegratedHotelApiActions,
  IReckonIntegratedHotelContainerActions,
} from './integrated-ireckon-hotel.actions';
import { initialState, adapter, selectIReckonIntegratedHotelIdFromHotel } from './integrated-ireckon-hotel.state';

export const integratedIReckonHotelReducer = createReducer(
  initialState,
  on(IReckonIntegratedHotelApiActions.integrationsLoaded, (state, { hotels }) => adapter.upsertMany(hotels, state)),
  on(
    IReckonIntegratedHotelApiActions.integrationsAdded,
    IReckonIntegratedHotelApiActions.integrationsUpdated,
    IReckonIntegratedHotelContainerActions.integrationUpdated,
    (state, { hotel }) => adapter.upsertOne(hotel, state)
  ),
  on(IReckonIntegratedHotelApiActions.integrationsAddedError, (state, { hotel }) =>
    adapter.removeOne(selectIReckonIntegratedHotelIdFromHotel(hotel), state)
  )
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectIntegratedIReckonHotelIds = selectIds;

export const selectIntegratedIReckonHotelEntities = selectEntities;

export const selectAllIntegratedIReckonHotels = selectAll;
